export class AddressType {
    id: number;
    code: string;
    name: string;
    constructor(
    ) { }
}